import { ShipmentAddress } from './shipment-address';
import { Address } from './address';
import { environment } from "../../../environments/environment";

export class Customer {
  constructor(
    private _id: string = null,
    private _type: string = null,
    private _client: string = null,
    private _email: string = null,
    public _phoneNr: string = null,
    private _isFromOnline: boolean = false,
    private _address: Address = null,
    private _shipmentAddress: ShipmentAddress = null,
    private _shipmentFromAddress: ShipmentAddress = null,

  ) {
    this._phoneNr = environment.defaultDialingCode + _phoneNr;

    if (this._phoneNr.startsWith(environment.defaultDialingCode + environment.defaultDialingCode)) {
      this._phoneNr = this._phoneNr.substr(3)
    }

  }

  get id(): string {
    return this._id;
  }

  get type(): string {
    return this._type;
  }

  get client(): string {
    return this._client;
  }

  get email(): string {
    return this._email;
  }

  get phoneNr(): string {
    return this._phoneNr;
  }

  get address(): Address {
    return this._address;
  }

  get shipmentAddress(): ShipmentAddress {
    return this._shipmentAddress;
  }

  get shipmentFromAddress(): ShipmentAddress {
    return this._shipmentFromAddress;
  }

  get isFromOnline(): Boolean {
    return this._isFromOnline;
  }

  static fromRaw(customerRaw: any): Customer {
    let address = null;
    switch (customerRaw.data.entity) {
      case 'person':
        address = Address.fromRawPerson(customerRaw.data.person_address);
        break;
      case 'freelancer':
        address = Address.fromRawFreelancer(customerRaw.data.freelancer_address);
        break;
      case 'company':
        address = Address.fromRawCompany(customerRaw.data.company_address);
        break;
    }
    let customer = new Customer(
      customerRaw.key,
      customerRaw.data.entity,
      customerRaw.data.client,
      customerRaw.data.email,
      customerRaw.data.phone_nr,
      customerRaw.data.isFromOnline,
      address
    );

    if (customerRaw.data.shipment_address) {
      customer = customer.withShipmentAddress(
        ShipmentAddress.fromRaw(customerRaw.data.shipment_address)
      );
    }

    if (customerRaw.data.shipment_from_address) {
      customer = customer.withShipmentFromAddress(
        ShipmentAddress.fromRaw(customerRaw.data.shipment_from_address)
      );
    }

    return customer;
  }

  withType(type: string): Customer {
    return new Customer(
      this._id,
      type,
      this._client,
      this._email,
      this._phoneNr,
      this._isFromOnline,
      this._address,
      this._shipmentAddress,
      this._shipmentFromAddress,
    );
  }

  withShipmentAddress(shipmentAddress: ShipmentAddress): Customer {
    return new Customer(
      this._id,
      this._type,
      this._client,
      this._email,
      this._phoneNr,
      this._isFromOnline,
      this._address,
      shipmentAddress,
      this._shipmentFromAddress,
    );
  }

  withShipmentFromAddress(shipmentFromAddress: ShipmentAddress): Customer {
    return new Customer(
      this._id,
      this._type,
      this._client,
      this._email,
      this._phoneNr,
      this._isFromOnline,
      this._address,
      this._shipmentAddress,
      shipmentFromAddress,
    );
  }

  getLegalName() {
    let legal_name = null;
    switch (this._type) {
      case 'person':
        return this._address.name + " " + this._address.surname;
      case 'freelancer':
        return this._address.name + " " + this._address.surname;
      case 'company':
        return this._address.companyName;
    }
  }

  toRaw(): any {
    const customerRaw = {
      entity: this._type,
      client: this._client,
      email: this._email,
      phone_nr: this._phoneNr,
      isFromOnline: this._isFromOnline,
    };
    if (this._shipmentAddress) {
      customerRaw['shipment_address'] = this._shipmentAddress.toRaw();
    }

    if (this._shipmentFromAddress) {
      customerRaw['shipment_from_address'] = this._shipmentFromAddress.toRaw();
    }
    customerRaw[this._type + '_address'] = this._address.toRaw(this._type);

    return customerRaw;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/model/customer.ts